import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Modal } from '@blend-ed/blendx-ui';
import ContactForm from './ContactForm';
import { useMediaQuery } from 'react-responsive';

const GetContactModal = () => {
  const [showModal, setShowModal] = useState(false);

  const isTablet = useMediaQuery({ minWidth: 768 });

  const handleCloseModal = () => {
    sessionStorage.setItem('modalClosed', 'true');
    setShowModal(false);
  };

  useEffect(() => {
    // Check if modal was previously closed in this session
    if (sessionStorage.getItem('modalClosed') === 'true' || localStorage.getItem('formSubmitted') === 'true') {
      return;
    }

    // Set modal to show after 10 seconds
    const timeoutId = setTimeout(() => {
      setShowModal(true);
    }, 10000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <Modal show={showModal} onClose={handleCloseModal} centered backdrop={false} fullscreen={!isTablet} className={`form-modal`}>
      <Modal.Header closeButton closeVariant='white' className='pt-5 z-1' />
      <Modal.Body className='px-lg-10 px-5 pt-0'>
        <Row className='align-items-center flex-column flex-lg-row modal-body__row'>
          <Col className='d-flex flex-column gap-4 text-start modal-body__col'>
            <h4 className='mb-0'>Love What You See?</h4>
            <p className="fs-3 mb-0 text-gray-600 modal-body__text">
              Let's Chat About How Blend-ed Can Deliver Impactful Training for Your Team.
            </p>
            {isTablet && <div className="d-flex flex-column text-gray-600 modal-body__list">
              <div className="d-flex gap-2 modal-body__list-item">
                <i className="ri-checkbox-circle-fill text-primary" />
                <p className="mb-0">We’re glad you’re exploring Blend-ed!</p>
              </div>
              <div className="d-flex gap-2 modal-body__list-item">
                <i className="ri-checkbox-circle-fill text-primary" />
                <p className="mb-0">Fill out the form, and one of our experts will reach out to show how Blend-ed can work for your organization.</p>
              </div>
              <div className="d-flex gap-2 modal-body__list-item">
                <i className="ri-checkbox-circle-fill text-primary" />
                <p className="mb-0">Get personalized guidance, tips, and a demo tailored to your needs.</p>
              </div>
            </div>}
          </Col>
          <Col className='d-flex justify-content-end'>
            <ContactForm buttonText='Talk to an expert' buttonAction={() => setShowModal(false)} />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className='border-0 py-lg-3 pb-lg-4'></Modal.Footer>
    </Modal>
  );
};

export default GetContactModal; 